import { useSessionStore } from "../stores/UserStore";
import { mainAxios } from "./axios";
import { publicHost } from "../functions/appHost";

const defaultAPI = "application.magileads.io";

export function extractDomainFromUrl(url) {
  const domainRegex = /^https?:\/\/([^/]+)\//;
  const match = url.match(domainRegex);

  if (match && match[1]) {
    let d = match[1];
    if (d === "localhost:3000") {
      return defaultAPI;
    }
    if (d === "arc:3000") {
      return defaultAPI;
    }
    return match[1];
  }

  return null;
}

export const getApiDetailsDomain = async () => {
  let response = await mainAxios.get(
    `/api/${extractDomainFromUrl(window.location.href)}`, {
    headers: { "Skip-Auth": true }
  }
  );

  if (response) {
    let data = response.data.api;
    mainAxios.defaults.baseURL = "https://" + data.domain_api;

    useSessionStore
      .getState()
      .setAppUrl(
        window.location.href.includes("localhost")
          ? "http://localhost:3000"
          : "https://" +
          publicHost(
            data.domain_saas.replace(
              "application.magileads.net",
              "application.magileads.io"
            )
          )
      );
    useSessionStore.getState().setReseller(data);
  }

  return response;
};

export const getCnames = async () => {
  return mainAxios.get(`/resellers/cnames`);
};

export const downloadExtension = async ({ id, name }) => {
  return mainAxios
    .get(`/resellers/${id}/download/extension/chrome`, { responseType: "blob" })
    .then((res) => {
      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${name} #${id}`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    });
};

export const getMessages = async () => {
  return mainAxios.get(`/resellers/messages`);
};

export const getMessagesReseller = async (reseller_id) => {
  return mainAxios.get(`/resellers/messages/${reseller_id}`);
};

export const editMessagesReseller = async ({
  id,
  name,
  language,
  subject,
  content
}) => {
  return mainAxios.post(`/resellers/${id}/messages`, {
    id, name,
    language,
    subject,
    content
  });
};

export const getResellerVideoUrl = async (reseller_id) => {
  return mainAxios.get(`/resellers/${reseller_id}/tutorial/videos`);
};

export const updateResellerVideoUrl = async ({ reseller_id, formData }) => {
  let r = await mainAxios.post(`/resellers/${reseller_id}/tutorial/videos`, formData, {
    headers: {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });

  return r
};

export const getResellerOptions = async (reseller_id) => {
  return mainAxios.get(`/resellers/${reseller_id}/options`);
};

export const updateResellerOptions = async ({ reseller_id, options }) => {
  return mainAxios.post(`/resellers/${reseller_id}/options`, { options });
};